<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Creative Approval</modal-header>
        </div>
        Are you sure you want to approve downloads for this creative?
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" :showBack="false" :hideCancelText="false" confirmText="Approve"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_approve_creative_downloads',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String
  },
  data: () => ({}),
  mounted () {},
  computed: {},
  methods: {
    confirm () {
      this.startLoading()
      this.approveCreativeDownloadApproval({
        hash_id: this.confirmId
      }).then(() => {
        this.getCreativeUnits(this.creativeUnits.data.creative.hash_id).then(() => {
          this.finishLoading()
        })
        this.close()
      })
    }
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-approve-creative-downloads.vue